// extracted by mini-css-extract-plugin
module.exports = {"campuses":"index-module--campuses--18u5V","campus":"index-module--campus--1ROSf","text":"index-module--text--2c0Hj"};